import React, { useState } from 'react';
import { useI18n } from '../../i18n';

export default function TryOnInfo({ label }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  return (
    <span className="ct-tryon-info">
      <span className="ct-tryon-term">{label || t('tryonInfo.term')}</span>
      <span
        role="button"
        tabIndex={0}
        className="ct-tryon-info-button"
        onClick={(event) => {
          event.stopPropagation();
          setOpen((value) => !value);
        }}
        onKeyDown={(event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopPropagation();
          setOpen((value) => !value);
        }}
        onBlur={() => window.setTimeout(() => setOpen(false), 120)}
        aria-label={t('tryonInfo.label')}
        aria-expanded={open}
      >
        i
      </span>
      {open ? (
        <span className="ct-tryon-tooltip" role="tooltip">
          {t('tryonInfo.tooltip')}
        </span>
      ) : null}
    </span>
  );
}
